import React, { CSSProperties } from 'react';

import Heading from '@atlaskit/heading';
import { Box } from '@atlaskit/primitives';
import Select, { StylesConfig, OptionType, GroupType } from '@atlaskit/select';

import { LabelSelectContainer } from './styles';

type MetricsGroupSelectLabelProps = {
  label: string;
  options: GroupType<OptionType>[];
  onOptionSelect: (option: OptionType) => void;
  selectName: string;
  placeholder: string;
  value?: OptionType;
};

/* eslint @typescript-eslint/ban-types: "warn" */
export const MetricsGroupSelectLabel: React.FC<
  MetricsGroupSelectLabelProps
> = ({
  label,
  options,
  onOptionSelect,
  selectName,
  placeholder,
  value,
}: MetricsGroupSelectLabelProps) => {
  return (
    <Box xcss={LabelSelectContainer}>
      <Heading size="small">{label}</Heading>
      {!options.length ? null : (
        <Select
          options={options}
          value={value}
          spacing="compact"
          placeholder={placeholder}
          name={selectName}
          isClearable
          isSearchable
          onChange={onOptionSelect}
          styles={
            {
              control: (css: CSSProperties) => ({
                ...css,
                minWidth: 100,
              }),
            } as StylesConfig
          }
        />
      )}
    </Box>
  );
};
